export default {
  Default: { library: 'pi', name: 'PiCurrencyCircleDollar' },
};
